/**
 * surchage de la configuration de la carte par type_zone (code pays)
 */

export const getDefaultBackgroundAliasForZone = (typeZone: string): string => {
  switch (typeZone) {
    case 'CIV':
    case 'SEN':
      return 'arcgis';
    default:
      return 'ign-sat';
  }
};

export const BACKGROUND_PROVIDERS = [
  {
    value: new Cesium.WebMapTileServiceImageryProvider({
      url : 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile',
      style : 'normal',
      format : 'image/jpeg',
    }),
    label: 'Arcgis',
    alias: 'arcgis'
  }, {
    value: new Cesium.OpenStreetMapImageryProvider({
      url: 'https://tile.openstreetmap.org/'
    }),
    label: 'OpenStreetMap',
    alias: 'osm'
  }, {
    value: new Cesium.WebMapTileServiceImageryProvider({
      url: 'https://data.geopf.fr/wmts',
      layer: 'ORTHOIMAGERY.ORTHOPHOTOS',
      style: 'normal',
      format: 'image/jpeg',
      tileMatrixSetID: 'PM',
      tileMatrixLabels: Array.from({ length: 20 }, (_, i) => i.toString()),
      maximumLevel: 19,
    }),
    label: 'IGN satellite',
    alias: 'ign-sat'
  }
];

export const BACKGROUND_DEFAULT = 'ign-sat';
